import React, { useEffect, useState } from 'react';
import MaterialIcon from '@/components/ui/MaterialIcon';
import { useInstallPrompt } from '@/hooks/useInstallPrompt';
import IOSInstallInstructions from './IOSInstallInstructions';

// Banner shown above the mobile bottom nav. Desktop never sees it.
const InstallPromptBanner: React.FC = () => {
  const { canPrompt, isIOS, isInstalled, isDismissed, promptInstall, dismiss } = useInstallPrompt();
  const [iosModalOpen, setIOSModalOpen] = useState(false);
  const [delayElapsed, setDelayElapsed] = useState(false);

  // Hold off displaying for a few seconds so the banner isn't the first thing the user sees.
  useEffect(() => {
    const timer = window.setTimeout(() => setDelayElapsed(true), 4000);
    return () => window.clearTimeout(timer);
  }, []);

  if (isInstalled || isDismissed || !delayElapsed) return null;
  if (!canPrompt && !isIOS) return null;

  const handleAction = async () => {
    if (canPrompt) {
      const accepted = await promptInstall();
      if (!accepted) dismiss();
      return;
    }
    if (isIOS) setIOSModalOpen(true);
  };

  return (
    <>
      <div
        role="region"
        aria-label="Installer l'application"
        className="md:hidden fixed left-0 right-0 z-50 px-3 animate-slide-up"
        style={{ bottom: 'calc(4.5rem + env(safe-area-inset-bottom))' }}
      >
        <div className="mx-auto max-w-[460px] flex items-center gap-3 rounded-2xl bg-gray-900 text-white shadow-xl border border-white/10 px-4 py-3">
          <img src="/favicon-192.png" alt="Leeris" className="h-10 w-10 shrink-0 rounded-xl" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold leading-tight">Installer l'application</p>
            <p className="text-xs text-gray-300 leading-tight mt-0.5">
              Accès rapide à votre carte, même hors ligne.
            </p>
          </div>
          <button
            type="button"
            onClick={handleAction}
            className="shrink-0 rounded-lg bg-primary text-[#102216] font-bold text-xs px-3 py-2 active:scale-95 transition-transform"
          >
            Installer
          </button>
          <button
            type="button"
            onClick={dismiss}
            aria-label="Fermer"
            className="shrink-0 p-1 text-gray-400 hover:text-white rounded-md transition-colors"
          >
            <MaterialIcon icon="close" style={{ fontSize: 18 }} />
          </button>
        </div>
      </div>

      <IOSInstallInstructions
        isOpen={iosModalOpen}
        onClose={() => setIOSModalOpen(false)}
      />
    </>
  );
};

export default InstallPromptBanner;
